export default {
  typography: {
    fontFamily: "Montserrat",
    fontSize: 12,
  },
  shape: {
    borderRadius: 0,
  },
  overrides: {
    MuiChip: {
      root: {
        borderRadius: 0,
      },
    },
    MuiInputBase: {
      root: {
        lineHeight: 0.8,
      },
    },
  },
};
